/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-15 09:28:58
 * @LastEditors: susj
 * @LastEditTime: 2020-10-20 10:17:57
 */
import insertObj from '@/utils/insertData';

const state = {
  insertData: insertObj.insertData, // 插入数据
  insertDataItem: insertObj.insertDataItem, // 插入某项
  setType: [],
  setTypeCur: 'bg',
};

const getters = {};

const mutations = {
  setInsertDataItem(state, payload) {
    state.insertDataItem = payload;
  },
  setSetType(state, payload) {
    state.setType = payload;
    state.setTypeCur = payload[0].val;
  },
  setSetTypeCur(state, payload) {
    state.setTypeCur = payload;
  },
};

const actions = {
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
